module.exports = __webpack_public_path__ + "static/media/calendar-alt-regular.3d7774c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/calendar-alt-regular.svg
// module id = 588
// module chunks = 0